

import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import { labelSearch } from '../services';
import Finder from './Finder';
import { ImplantListGroupItem } from './ImplantCard';
import Spinner from './Spinner';

const LabelSearch = ({ onChange }) => {
    const { t } = useTranslation();
    const inputFile = useRef(null);
    const [labelFile, setLabelFile] = useState(undefined);
    const labelBlob = labelFile ? URL.createObjectURL(labelFile) : '';
    const [implantModelCandidates, setImplantModelCandidates] = useState(undefined);

    const [implantModel, setImplantModel] = useState(undefined);


    const [isLoading, setIsLoading] = useState(true);


    const onLabelChange = async (event) => {
        const file = Object(event.currentTarget.files)[0];
        setLabelFile(file);

        setIsLoading(true);

        let data;
        try {
            data = await labelSearch(file);
        } catch (e) {
            setIsLoading(false);
        }

        setIsLoading(false);
        setImplantModelCandidates(data.implant_models);
    };

    useEffect(() => {
        inputFile.current.click();
        setTimeout(function () {
            setIsLoading(false);
        }, 500);

    }, []);


    const hasCandidates = implantModelCandidates && implantModelCandidates.length;

    return <>
        {!labelFile ?
            <>
                {isLoading ? <Spinner /> : ""}
                <div className="col-md-6 offset-md-3" style={{ display: isLoading ? "none" : "block" }}>
                    <label className="btn btn-primary btn-lg rounded-pill btn-block" style={{ fontSize: "1rem" }}>
                        {t("Submit implant label picture")} <i className="fas fa-camera"></i> <input type="file" ref={inputFile} hidden onChange={onLabelChange} />
                    </label>
                </div>
            </>
            : ''}

        {labelFile ? <>
            <div className="row">

                <div className="col-md-6">

                    {labelFile && isLoading ? <Spinner /> : ''}

                    {!implantModel && !isLoading && hasCandidates ?
                        <>
                            <p><b>{t("Confirm implant model")}:</b></p>
                            <div className="list-group implant-model-confirmation" style={{ marginBottom: "10px" }}>
                                {implantModelCandidates.map((item, idx) => {
                                    return <ImplantListGroupItem key={idx} implant={item} onClick={() => onChange(item)} />;
                                })
                                }
                            </div>

                            <p>{t("The implant is not listed")}? <NavLink to={"/manual"}>{t("Try searching manually")}</NavLink></p>

                        </> : ''}

                    {!implantModel && !isLoading && !hasCandidates ?
                        <div><p>{t('Not found')}, {t("Try searching manually")}:</p>

                            <Finder hasSearchBar={false} layout={"vertical"} />
                        </div>

                        : ''}


                </div>
                <div className="col-md-4" style={{ textAlign: "center" }}>
                    <img src={labelBlob} className="img-thumbnail label-thumbnail" alt="label" />
                    <label className="btn btn-link btn-block">{t("Choose another image")} <input type="file" hidden onChange={onLabelChange} />
                    </label>
                </div>
            </div></> : ''}
    </>;
};


export const BarcodeIcon = (props) => {
    return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="24" height="24" viewBox="0 0 200.000000 200.000000"
        preserveAspectRatio="xMidYMid meet" {...props}>

        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M185 1696 c-37 -16 -70 -52 -84 -89 -6 -16 -11 -80 -11 -143 l0 -114
40 0 40 0 0 115 c0 110 1 117 25 140 23 24 30 25 140 25 l115 0 0 40 0 40
-117 0 c-76 -1 -129 -6 -148 -14z"/>
            <path d="M1570 1671 l0 -41 115 0 c110 0 117 -1 140 -25 24 -23 25 -30 25
-140 l0 -115 41 0 41 0 -4 129 c-3 141 -10 159 -72 205 -24 18 -45 21 -157 24
l-129 4 0 -41z"/>
            <path d="M330 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M490 1290 l0 -180 80 0 80 0 0 180 0 180 -80 0 -80 0 0 -180z" />
            <path d="M730 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M890 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1050 1290 l0 -180 80 0 80 0 0 180 0 180 -80 0 -80 0 0 -180z" />
            <path d="M1290 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1450 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1610 1290 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M182 1018 c-16 -16 -15 -43 2 -57 10 -8 235 -10 831 -9 766 3 819 4
829 20 8 13 8 23 0 35 -10 17 -63 18 -831 21 -629 2 -822 -1 -831 -10z"/>
            <path d="M330 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M490 690 l0 -180 80 0 80 0 0 180 0 180 -80 0 -80 0 0 -180z" />
            <path d="M730 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M890 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1050 690 l0 -180 80 0 80 0 0 180 0 180 -80 0 -80 0 0 -180z" />
            <path d="M1290 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1450 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M1610 690 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
            <path d="M92 501 c3 -141 10 -159 72 -205 24 -18 45 -21 157 -24 l129 -4 0 41
0 41 -115 0 c-110 0 -117 1 -140 25 -24 23 -25 30 -25 140 l0 115 -41 0 -41 0
4 -129z"/>
            <path d="M1850 515 c0 -110 -1 -117 -25 -140 -23 -24 -30 -25 -140 -25 l-115
0 0 -41 0 -41 129 4 c112 3 133 6 157 24 62 46 69 64 72 205 l4 129 -41 0 -41
0 0 -115z"/>
        </g>
    </svg>;

};

export default LabelSearch;